import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import Tabela2 from "../../../Componentes/Utils/Tabela2";
import axios from "axios";
import { useEffect, useState } from "react";
import { useModal } from "../../../contexts/ModalContext";
import ModalNovoTipo from "./ModalNovoTipo";
import { GoTrash } from "react-icons/go";
import ModalDeleteTipo from "./ModalDeleteTipo";

const CabecalhoModal = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
`
const TituloModal = styled.h1`
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    color: #333;
`
const BotaoAdd = styled.button`
    background-color: #007bff;
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    align-items: center;
    &:hover {
        background-color: #0056b3;
    }
`
const Container = styled.div`
    width: 100%;
    height: 350px;
`
const CelulaAcao = styled.td`
    text-align: center;
    width: 50px;
`
const IconeLixeira = styled( GoTrash )`
    color: red;
    cursor: pointer;
    width: 20px;
    height: 20px;
    &:hover {
        opacity: 0.7;
        scale: 1.1;
    }
    transition: all 0.2s ease-in-out;
`

const ModalCatalogoTipoRisco = ({ categoria, fecharModal, updateCategorias }) => {

    const { isModalOpen, openModal, closeModal } = useModal();

    const [ tiposRisco, setTiposRisco ] = useState([]);

    const getData = async() => {

        try{

            const { data } = await axios.post("https://sistemaintegrado.palmont.com.br/Painel/API/Desvios/TiposRiscosCat/", {
                "categoria": categoria.uuid
            })

            setTiposRisco( data );

        }catch( error ){
            console.error( error );
        }

    }

    useEffect(() => {

        getData();

    }, [ categoria ])

    const openNovoTipoRisco = () => {

        openModal('ModalNovoTipoRisco');

    }

    const [ selectedTipo, setSelectedTipo ] = useState(null);

    const openDeleteTipoRisco = ( tipo ) => {

        setSelectedTipo( tipo );
        openModal('ModalDeleteTipoRisco');

    }

    const closeDeleteTipoRisco = () => {

        setSelectedTipo( null );
        closeModal();

    }

    return(
        <>
            <Overlay state={ true } >
                <Modal size="lg" header close={ fecharModal } >
                    <CabecalhoModal>
                        <TituloModal>
                            CATÁLOGO TIPOS DE RISCO - { categoria.nome }
                        </TituloModal>
                        <BotaoAdd onClick={ openNovoTipoRisco } >
                            ADICIONAR
                        </BotaoAdd>
                    </CabecalhoModal>
                    <Container>
                        <Tabela2>
                            <thead>
                                <tr>
                                    <th>TIPO DE RISCO</th>
                                    <th>CLASSIFICAÇÃO</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    tiposRisco.map(( tipo ) => (
                                        <tr key={ tipo.uuid } >
                                            <td>{ tipo.tipo }</td>
                                            <td>{ tipo.classificacao_desc  }</td>
                                            <CelulaAcao>
                                                <IconeLixeira onClick={ () => openDeleteTipoRisco( tipo ) } />
                                            </CelulaAcao>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Tabela2>
                    </Container>
                </Modal>
                {
                    isModalOpen('ModalNovoTipoRisco') && (
                        <ModalNovoTipo
                            categoria={ categoria }
                            updateTipos={ getData }
                            updateCategorias={ updateCategorias }
                        />
                    )
                }
                {
                    isModalOpen('ModalDeleteTipoRisco') && (
                        <ModalDeleteTipo
                            tipo={ selectedTipo }
                            fecharModal={ closeDeleteTipoRisco }
                            updateData={ getData }
                            updateCategorias={ updateCategorias }
                        />
                    )
                }
            </Overlay>
        </>
    )
}

export default ModalCatalogoTipoRisco;